import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  Compiler,
  ComponentFactoryResolver
} from '@angular/core';
import { StaticContentService } from './static-content.service';
import { ActivatedRoute } from '@angular/router';
import {
  AEMRoutes,
  RoutePrefix,
  TrackAndTraceRoutes,
  OrderRoutes,
  ProductRoutes,
  UserRoutes
} from '../../core/constants/routes.constant';
import { AppUtilService } from '../../core/utils/app-util.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import {
  BUID,
  CacheConstant,
  CacheDuration,
  CMSPages
} from '../../core/constants/app.constant';
import { DomSanitizer } from '@angular/platform-browser';
import { ScriptService } from '../../core/services/script.service';
import { AemComponent } from './aem/aem.component';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { CmsService } from '../../core/services/cms.service';
import { StaticPageContent } from '../../shared/models/cms';
declare var $: any;

@Component({
  selector: 'par-static-content',
  templateUrl: './static-content.component.html',
  styleUrls: ['./static-content.component.scss']
})
export class StaticContentComponent implements OnInit, OnDestroy {
  /***************Properties***************/
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  //cmsContentFlag = this.envProperties.cmsContentFlag ? this.envProperties.cmsContentFlag.toBoolean() : false;
  cmsPageName: any;
  templateNum: any;
  buId = this.envProperties.buId;
  cmsPageConfigVO = this.envProperties.cmsPageConfigVO;
  requestParams: any;

  private routeDataSubscription: Subscription;
  private contentReplaces = [
    { string: new RegExp('src="', 'gi'), value: 'src="' + this.envProperties.aemUrl },
    {
      string: 'background:url(',
      value: 'background:url(' + this.envProperties.aemUrl
    },
    {
      string: 'https://cardinalb2b.okta.com/home/cardinalhealthincb2b_parmedcsos_1/0oa8hqhgtsA1ByeKO1t7/aln8hqli9gZeb3rv21t7',
      value: this.envProperties.axWayRegisterUrl
    },
    {
      string: 'https://cardinalb2b.okta.com/home/cardinalhealthincb2b_parmedbillerdirect_1/0oa8kgi321W947AKX1t7/aln8kgpbbyY2q3i0E1t7/',
      value: this.envProperties.billerDirectUrl
    }
  ];
  isAuthenticated: Boolean = this.authService.isAuthenticated();
  routes = {
    register: '/' + RoutePrefix.Register,
    dscsa: '/' + TrackAndTraceRoutes.SearchTransactionData,
    orderHistory: '/' + OrderRoutes.OrderHistory,
    accountSettings: '/' + UserRoutes.WebAccountSettings,
    creditCards: '/' + RoutePrefix.CreditCards,
    productHistory: '/' + ProductRoutes.ProductHistory,
    csosOrderHistory: '/' + OrderRoutes.CsosOrderHistory,

  };
  aem = {
    styleUrl: " ",
    // this.sanitizer.bypassSecurityTrustResourceUrl(
    //   this.envProperties.aemUrl + '/etc/designs/parmed/clientlibs.min.css'
    // ),
    html: null,
    loaded: false,
    success: false
  };
  productCatlogs = {
    show: false,
    catalogs: []
  };
  myAccountLinks = [
    { label: 'Pay on accounts', route: '/' + RoutePrefix.MyHome },
    {
      label: 'DSCSA data',
      route: '/' + TrackAndTraceRoutes.SearchTransactionData
    },
    { label: 'Order tracking', route: '/' + OrderRoutes.OrderHistory },
    { label: 'Account settings', route: '/' + UserRoutes.WebAccountSettings },
    { label: 'Manage credit cards', route: '/' + RoutePrefix.CreditCards },
    {
      label: 'Recently ordered products',
      route: '/' + ProductRoutes.ProductHistory
    },
    {
      label: 'Submitted CSOS orders',
      route: '/' + OrderRoutes.CsosOrderHistory
    },
    {
      label: 'Account balance and current statement',
      route: '/' + RoutePrefix.MyHome
    }
  ];
  @ViewChild('aemContentContainer', { read: ViewContainerRef, static: true })
  aemContainer: ViewContainerRef;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    private sanitizer: DomSanitizer,
    private staticContentService: StaticContentService,
    private cmsService: CmsService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private script: ScriptService,
    private componentFactoryResolver: ComponentFactoryResolver
  ) { }

  ngOnInit() {
    // this.loadAEMScript();    
    this.route.queryParamMap.subscribe(params => {
      this.requestParams = params;
    });
    this.routeDataSubscription = this.route.data.subscribe(data => {
      
      this.onRouteDataChage(data);
    });
  }

  ngOnDestroy(): void {
    if (this.routeDataSubscription) {
      this.routeDataSubscription.unsubscribe();
    }

    if (this.aemContainer) {
      this.aemContainer.clear();
    }
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  OnCatalogClick(catalogData) {
    AppUtilService.cache.set(
      CacheConstant.Catalog_Data,
      catalogData,
      CacheDuration.OneHour
    );
    AppUtilService.router.navigate([ProductRoutes.ProductCatalog]);
  }

  /***************Component Methods***************/

  /***************Private Methods***************/

  // private loadAEMScript() {
  //   // this.script.load({
  //   //   src: this.envProperties.aemUrl + '/etc/designs/parmed/clientlibs.min.js',
  //   //   loaded: false
  //   // });
  // }

  private onRouteDataChage(data) {
    if (data.aemUrl) {
      this.loadAemContent(data.aemUrl);

      if (AppUtilService.router.url === '/' + AEMRoutes.Shop) {
        this.getProductCatalogsForShop();
      }
    } else {
      const redirectRoute = this.isAuthenticated
        ? RoutePrefix.MyHome
        : RoutePrefix.Home;
      AppUtilService.router.navigate([redirectRoute]);
    }
  }

  private loadAemContent(aemUrl: string) {
    let cmsEnabledURLs: string[] = [
      '/content/parmed/employment.html',
      '/content/parmed/legal.html',
      '/content/parmed/privacy.html',
      '/content/parmed/productsandservices.html',
      '/content/parmed/aboutus.html',
      '/content/parmed/Help.html',
      '/content/parmed/customerforms.html',
      '/content/parmed/shop/CSOSHelp.html',
      '/assets/static-content/majorPrivacy.html',
      '/assets/static-content/majorlegal.html',
      '/assets/static-content/majorNews.html',
      '/assets/static-content/aboutus.html',
      '/assets/static-content/majorHelp.html',
      '/assets/static-content/majorProductAndServices.html',
      '/content/parmed/subscriptionsHelp.html',
      '/content/parmed/welcome.html',
      '/content/parmed/newaccounts.html',
      '/content/parmed/sds.html',
      '/content/parmed/emedbinaxNOW.html',
      '/content/parmed/dscsa.html'
    ];
    if (cmsEnabledURLs.includes(aemUrl)) {
      let sequenceNumber: number = this.getSequenceNumber(aemUrl);
      this.loadCMSContent(aemUrl, sequenceNumber);
    }
    else {
      let aemURL = '';
      if (this.envProperties.theme == 'Parmed') {
        aemURL = this.envProperties.aemUrl;
      }
      this.staticContentService
        .getAemContent(aemURL + aemUrl)
        .subscribe((res: any) => {
          this.aem.success = !res.hasError;

          if (this.aem.success) {
            let content: string = $(res)
              .find('#main-content-wrapper')
              .html()
              .toString();

            this.contentReplaces.forEach(rep => {
              content = content.replace(rep.string, rep.value);
            });

            setTimeout(() => {
              this.aem.loaded = true;
              this.loadAemComponent(content);
            }, 100);
          } else {
            this.aem.loaded = true;
            this.aem.html = '';

            if (this.authService.isAuthenticated()) {
              this.getProductCatalogsForShop();
            }
          }
        }
        );
    }
  }

  getSequenceNumber(aemUrl: string) {
    let sequenceNumber: number = 0;
    switch (aemUrl) {
      case '/content/parmed/employment.html': sequenceNumber = this.cmsPageConfigVO.empOpportunitySeqNo; break;
      case '/content/parmed/legal.html': sequenceNumber = this.cmsPageConfigVO.legalSeqNo; break;
      case '/content/parmed/privacy.html': sequenceNumber = this.cmsPageConfigVO.privacyPolicySeqNo; break;
      case '/content/parmed/productsandservices.html': sequenceNumber = this.cmsPageConfigVO.productServicesSeqNo; break;
      case '/content/parmed/aboutus.html': sequenceNumber = this.cmsPageConfigVO.aboutUsSeqNo; break;
      case '/content/parmed/Help.html': sequenceNumber = this.cmsPageConfigVO.helpSeqNo; break;
      case '/content/parmed/customerforms.html': sequenceNumber = this.cmsPageConfigVO.customerFormsSeqNo; break;
      case '/content/parmed/shop/CSOSHelp.html': sequenceNumber = this.cmsPageConfigVO.csosHelpSeqNo; break;
      case '/assets/static-content/majorlegal.html': sequenceNumber = this.cmsPageConfigVO.legalSeqNo; break;
      case '/assets/static-content/majorPrivacy.html': sequenceNumber = this.cmsPageConfigVO.privacyPolicySeqNo; break;
      case '/assets/static-content/majorNews.html': sequenceNumber = this.cmsPageConfigVO.newsSeqNo; break;
      case '/assets/static-content/aboutus.html': sequenceNumber = this.cmsPageConfigVO.aboutUsSeqNo; break;
      case '/assets/static-content/majorHelp.html': sequenceNumber = this.cmsPageConfigVO.helpSeqNo; break;
      case '/assets/static-content/majorProductAndServices.html': sequenceNumber = this.cmsPageConfigVO.productServicesSeqNo; break;
      case '/content/parmed/subscriptionsHelp.html': sequenceNumber = this.cmsPageConfigVO.subscriptionsSeqNo; break;
      case '/content/parmed/welcome.html': sequenceNumber = this.cmsPageConfigVO.registerExistingUserSeqNo; break;
      case '/content/parmed/newaccounts.html': sequenceNumber  = this.cmsPageConfigVO.registerNewUserSeqNo; break;
      case '/content/parmed/sds.html': sequenceNumber  = this.cmsPageConfigVO.sdsSeqNo; break;
      case '/content/parmed/emedbinaxNOW.html': sequenceNumber  = this.cmsPageConfigVO.emedbinaxNOW; break;
      case '/content/parmed/dscsa.html': sequenceNumber  = this.cmsPageConfigVO.dscsaSeqNo; break;
    }
    return sequenceNumber;
  }

  private loadCMSContent(cmsUrl: string, sequenceNumber: number) {
    this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    this.cmsService
      .getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, sequenceNumber)
      .subscribe((res: any) => {
        this.aem.success = !res.hasError;
        if (res.length > 0) {
          let staticPageContent: StaticPageContent = res[0];
          let htmlTextContent = "";
          if (sequenceNumber == this.envProperties.cmsPageConfigVO.newsSeqNo) {
            htmlTextContent = this.cmsService.prepareNewsStaticPageContents(staticPageContent, this.buId);
          } else if (sequenceNumber == this.envProperties.cmsPageConfigVO.productServicesSeqNo) {
            htmlTextContent = this.cmsService.prepareProductServicesStaticPageContents(staticPageContent, this.buId);
          } else if (sequenceNumber == this.envProperties.cmsPageConfigVO.customerFormsSeqNo 
            || sequenceNumber == this.envProperties.cmsPageConfigVO.helpSeqNo 
            || sequenceNumber == this.envProperties.cmsPageConfigVO.csosHelpSeqNo
            || sequenceNumber == this.envProperties.cmsPageConfigVO.emedbinaxNOW) {
            htmlTextContent = this.cmsService.prepareButtonLiksStaticPageContents(staticPageContent, this.buId);
          } else if (sequenceNumber == this.envProperties.cmsPageConfigVO.aboutUsSeqNo) {
            htmlTextContent = this.cmsService.prepareGenericStaticPageContents(staticPageContent);
          } else if (sequenceNumber == this.envProperties.cmsPageConfigVO.subscriptionsSeqNo) {
            htmlTextContent = this.cmsService.prepareSubscriptionsStaticPageContents(staticPageContent);
            setTimeout(() => {this.scrollPageToElement("terms-and-conditions")}, 1000);
          } else {
            htmlTextContent = this.cmsService.prepareStaticPageContents(staticPageContent);
          }
          if (this.aem.success) {
            setTimeout(() => {
              this.aem.loaded = true;
              this.loadAemComponent(htmlTextContent);
            }, 100);
          } else {
            this.aem.loaded = true;
            this.aem.html = '';
            if (this.authService.isAuthenticated()) {
              this.getProductCatalogsForShop();
            }
          }
        }
      });
  }

  private scrollPageToElement(htmlElementId: string) {
    if (this.requestParams.params) {
      if (this.requestParams.params.section == htmlElementId) {        
        var elmnt = document.getElementById(htmlElementId); 
        if (elmnt) {
          elmnt.scrollIntoView();
        }
      }
    };
  }

  private getProductCatalogsForShop() {
    this.staticContentService.getProductCatalog().subscribe((res: any) => {
      if (!res.hasError) {
        this.productCatlogs.show = true;
        this.productCatlogs.catalogs = res;
      }
    });
  }

  private loadAemComponent(tpl: any) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AemComponent);

    const componentRef = this.aemContainer.createComponent(componentFactory);
    (<AemComponent>componentRef.instance).template = this.sanitizer.bypassSecurityTrustHtml(tpl);
  }

  /***************Private Methods***************/
}
